export default __webpack_public_path__ + "static/media/2020 GENERAL INFORMATION SHEET (GIS).77113d19.pdf";